/* eslint-disable metabase/no-color-literals -- this file is the single source of Semipublic brand hex values */

/**
 * Semipublic design system tokens (SEM-182).
 *
 * Source: "Semipublic Design System" `tokens/colors.css`, derived from the
 * Semipublic Brand Guide (June 2026). Theme files, chart palettes and other
 * branded surfaces should reference these values instead of repeating hex
 * literals, so a brand update only has to touch this file.
 */
export const SEMIPUBLIC_COLORS = {
  // Brand core
  forest: "#244736",
  green: "#48A64F",
  sky: "#95D8ED",
  powder: "#E2EDFF",
  cream: "#F8F8E3",
  coral: "#F15539",

  // Forest ramp
  "forest-900": "#162C21",
  "forest-800": "#1D3A2B",
  "forest-700": "#244736",
  "forest-600": "#305C46",
  "forest-500": "#3F7358",
  "forest-400": "#5B9179",
  "forest-300": "#8BB5A3",
  "forest-200": "#BCD6CB",
  "forest-100": "#E0ECE7",
  "forest-50": "#F1F7F4",

  // Green ramp
  "green-700": "#2F7D38",
  "green-600": "#3B9243",
  "green-500": "#48A64F",
  "green-400": "#6CBB70",
  "green-300": "#97D199",
  "green-200": "#C3E6C4",
  "green-100": "#E6F4E7",

  // Sky ramp
  "sky-600": "#4FB4D9",
  "sky-500": "#78CBE6",
  "sky-400": "#95D8ED",
  "sky-300": "#B6E4F2",
  "sky-200": "#D5F0F8",

  // Coral ramp
  "coral-600": "#D63F24",
  "coral-500": "#F15539",
  "coral-400": "#F5795F",
  "coral-300": "#F9A794",
  "coral-200": "#FCD0C5",

  // Neutrals (warm, forest-leaning grays)
  ink: "#17211C",
  "gray-900": "#2A322D",
  "gray-700": "#4C554F",
  "gray-500": "#7B837D",
  "gray-400": "#A3AAA4",
  "gray-300": "#CCD0CB",
  "gray-200": "#E5E8E3",
  "gray-100": "#F2F4EF",
  white: "#FFFFFF",
} as const;

const sp = SEMIPUBLIC_COLORS;

/**
 * Chart series order. The first four follow the brand guide's data-viz order
 * (green → sky → forest → coral); the last four are lighter/darker steps of
 * the same hues so 5+ series charts stay on-palette.
 */
export const SEMIPUBLIC_CHART_COLORS = [
  sp.green,
  sp.sky,
  sp.forest,
  sp.coral,
  sp["green-300"],
  sp["sky-600"],
  sp["forest-300"],
  sp["coral-300"],
] as const;

/**
 * The brand guide has no dedicated "filter" hue. Metabase needs one that is
 * distinct from brand (forest) and summarize (green), and dark enough to be
 * used as text, so it is derived from sky-600 mixed 40% toward forest
 * (4.05:1 on white). Kept as a literal hex because JS color helpers parse it.
 */
export const SEMIPUBLIC_FILTER_COLOR = "#3E8898";

export const SEMIPUBLIC_SHADOW_COLOR = "rgba(23, 33, 28, 0.12)";

export const SEMIPUBLIC_FONTS = {
  body: "Montserrat",
  heading: "PT Serif",
} as const;
